var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-play',
                        view: publicPath + 'sprite.svg#view-icon-play',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/play',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };